import React from 'react';
import { injectIntl } from 'react-intl';
import PunchCardClient from './PunchCardClient.js';
import FloatingLayerPublic from './FloatingLayerPublic.js';
import FloatingLayer from '../builder/FloatingLayer.js';

const PunchCardStandalone = ({ type = 'inline', ...props }) => {
	const is_builder = props?.is_builder ?? false;

	const default_props = {
		stage:{ Stage:props.stage?.Stage ?? props.stage },
		promotion:props.promotion,
		participations:props.participations,
		only_display:true,
		is_completed:props?.is_completed ?? false,
		is_builder,
		force_num_stamps:props.force_num_stamps,
	};

	if(type == 'layer' && is_builder) {
		return (
			<FloatingLayer
				backButton={props.backButton}
				_class={{ size:'small' }}
			>
				<div class="without_actions">
					<PunchCardClient
						{...default_props}
						only_contents={true}
						extra_contents={props.extra_contents}
					/>
				</div>
			</FloatingLayer>
		)
	}

	if(type == 'layer') {
		return (
			<FloatingLayerPublic
				backButton={props.backButton}
			>
				<PunchCardClient {...default_props} />
			</FloatingLayerPublic>
		)
	}

	return (
		<div>
			<PunchCardClient {...default_props} />
		</div>
	)
};

export default injectIntl(PunchCardStandalone);